import { put, takeLatest, select } from 'redux-saga/effects';
import { shoppingCartActions as actions } from '.';
import * as querystring from 'qs';
import { ShoppingCartResponse, ShoppingCartPayload } from './types';
import {
  selectErpSystem,
  selectLanguageId,
} from '../../erpSystem/slice/selectors';
import { TARGET_SYSTEM } from '../../../../constants';

export function* fetchShoppingCart() {
  const { getShoppingCartSuccess, getShoppingCartError } = actions;
  const erpSystem = yield select(selectErpSystem);
  const languageId = yield select(selectLanguageId);
  const payload: ShoppingCartPayload = {
    locale: languageId,
    erpSystem,
    targetSystem: TARGET_SYSTEM,
  };
  try {
    const shoppingCartResponse = yield fetch(
      `/gasket-configurator/api/shoppingCart?${querystring.stringify(payload)}`,
    );
    if (shoppingCartResponse.status !== 200) {
      return yield put(getShoppingCartError('failed to fetch'));
    } else {
      const shoppingCart: ShoppingCartResponse =
        yield shoppingCartResponse.json();
      return yield put(
        getShoppingCartSuccess(shoppingCart.x_totalOrderItemCount),
      );
    }
  } catch (e) {
    return yield put(getShoppingCartError(e));
  }
}

export function* shoppingCartSaga() {
  yield takeLatest(actions.getShoppingCart.type, fetchShoppingCart);
}
